/********************************************************************
 * ADOBE CONFIDENTIAL
 * __________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *******************************************************************/

export default (
  fieldsConfig: Array<{
    customUpperCode?: string;
    required?: boolean;
    defaultValue?: unknown;
  }>
): {
  initialData: Record<string, unknown>;
  errorList: Record<string, string>;
} => {
  return fieldsConfig.reduce(
    (
      acc: {
        initialData: Record<string, unknown>;
        errorList: Record<string, string>;
      },
      { customUpperCode, required, defaultValue }
    ) => {
      if (required && customUpperCode) {
        acc.initialData[customUpperCode] = defaultValue || '';
        acc.errorList[customUpperCode] = '';
      }

      return acc;
    },
    {
      initialData: {},
      errorList: {},
    }
  );
};
